// extracted by mini-css-extract-plugin
export default {"pageHeader":"ErrorPage_pageHeader__J4WSf"};